(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-header-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-header-menu')) {
  customElements.define('gg-header-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.listenerOptions = { signal: this.controller.signal };
      this.header = this.closest('header');
      this.dialog = this.querySelector('dialog');
      this.triggers = Array.from(this.header.querySelectorAll('[aria-controls="MenuDrawer"]'));
      this.triggers.forEach(trigger => trigger.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.previousFocus = trigger;
        this.showPanel('root');
        this.dialog.showModal();
        document.documentElement.classList.add('gg-menu-open');
        trigger.setAttribute('aria-expanded', 'true');
      }, { capture: true, signal: this.controller.signal }));
      this.querySelector('[data-gg-close]').addEventListener('click', () => this.dialog.close(), this.listenerOptions);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('gg-menu-open');
        this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        this.previousFocus?.focus();
      }, this.listenerOptions);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, this.listenerOptions);
      this.querySelectorAll('[data-gg-panel]').forEach(button => button.addEventListener('click', () => {
        this.panelTrigger = button;
        this.showPanel(button.dataset.ggPanel, true);
      }, this.listenerOptions));
    }
    showPanel(name, focus = false) {
      this.querySelectorAll('[data-gg-view]').forEach(view => { view.hidden = view.dataset.ggView !== name; });
      this.querySelector('.gg-mobile-scroll').scrollTop = 0;
      if (focus) {
        if (name === 'root') this.querySelector('[data-gg-view="root"] [data-gg-panel]')?.focus();
        else this.querySelector(`[data-gg-view="${name}"] button`)?.focus();
      }
    }
    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      document.documentElement.classList.remove('gg-menu-open');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-product-review-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-product-review-card')) {
  customElements.define('gg-product-review-card', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
      this.index = 0;
      this.controller = new AbortController();
      this.options = { signal: this.controller.signal };
      this.autoplay = this.dataset.autoplay === 'true';
      this.paused = !this.autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.pauseButton = this.querySelector('[data-review-pause]');
      this.querySelector('[data-review-next]')?.addEventListener('click', () => {
        this.paused = true;
        this.advance(true);
        this.schedule();
      }, this.options);
      this.pauseButton?.addEventListener('click', () => {
        this.paused = !this.paused;
        if (!this.paused) { this.focused = false; this.hovered = false; }
        this.schedule();
      }, this.options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, this.options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, this.options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, this.options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, this.options);
      document.addEventListener('visibilitychange', () => this.schedule(), this.options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.2 });
      this.observer.observe(this);
      this.schedule();
    }
    advance(announce = false) {
      if (this.slides.length < 2) return;
      this.slides[this.index].hidden = true;
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].hidden = false;
      if (announce) this.querySelector('[data-review-status]').textContent = this.dataset.positionLabel.replace('[current]', String(this.index + 1));
    }
    schedule() {
      clearInterval(this.timer);
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
      }
      if (!this.autoplay || this.paused || this.hovered || this.focused || !this.inView || document.hidden || this.slides.length < 2) return;
      this.timer = setInterval(() => this.advance(), Math.max(3000, Number(this.dataset.interval) || 5000));
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
